module.exports = {"title":"Start your new journey with [greyd]!","reviewer":{"title":"Apply Reviewer","content":"We're looking for new greyders (reviewers)","hashtag":"#reviewer #greyder #authenticreviews  #getpaidtoreviewproducts"},"seller":{"title":"Apply Seller","content":"We’re looking for sellers to enter the greyd platform.","hashtag":"#seller #sellerregistration #easy #5minuteregistration"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/register.json
// module id = ag71
// module chunks = 1